export default __webpack_public_path__ + "static/media/3334 utensils top.4b5217f5.png";